import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ColorFactorPipe } from './pipes/color-factor/color-factor.pipe'
import { FindArrayPipe } from './pipes/find-array/find-array.pipe'
import { FileToBase64Pipe } from './pipes/image/file-to-base64.pipe'
import { MapInTemplatePipe } from './pipes/map/map-in-template.pipe'
import { ToSimpleListPipe } from './pipes/map/map-simple-list.pipe'
import { ToSelectItemsPipe } from './pipes/map/map-to-select-item.pipe'
import { MatchInTemplatePipe } from './pipes/match/match-in-template.pipe'
import { PrettyJsonPipe } from './pipes/pretty-json/pretty-json.pipe';
import { ExcludeSelectedOptionsPipe } from './pipes/exclude-selected-options/exclude-selected-options.pipe';
import { HashMapPipe } from './pipes/hash-map/hash-map.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PrettyJsonPipe,
    FileToBase64Pipe,
    MapInTemplatePipe,
    MatchInTemplatePipe,
    ColorFactorPipe,
    ToSelectItemsPipe,
    FindArrayPipe,
    ToSimpleListPipe,
    ExcludeSelectedOptionsPipe,
    HashMapPipe
  ],
  exports: [
    PrettyJsonPipe,
    FileToBase64Pipe,
    MapInTemplatePipe,
    MatchInTemplatePipe,
    ColorFactorPipe,
    ToSelectItemsPipe,
    FindArrayPipe,
    ToSimpleListPipe,
    ExcludeSelectedOptionsPipe,
    HashMapPipe
  ]
})
export class DomainModule { }
